import * as T from "../../utilities/frontendTypes";
import { AdminEmailPreferences } from "@eip/shared/types";
import { queryKeys } from "../../utilities/queryKeys";
import { useMutationWithUI } from "../../utilities/useMutationWithUI";
import { createUserProfile, createExpertProfile, createServiceProviderProfile } from "./profileService";
import { updateAdminEmailPreferences } from "./emailPreferencesService";

export function useCreateUserProfile() {
  return useMutationWithUI({
    mutationFn: (profile: T.NewUserProfile) => createUserProfile(profile),
    invalidateKeys: [queryKeys.adminProfiles.all],
    successMessage: "User profile created",
  });
}

export function useCreateExpertProfile() {
  return useMutationWithUI({
    mutationFn: (newExpert: T.User) => createExpertProfile(newExpert),
    invalidateKeys: [queryKeys.adminProfiles.all],
    successMessage: "Expert profile created",
  });
}

export function useCreateSpProfile() {
  return useMutationWithUI({
    mutationFn: (newServiceProvider: T.User) => createServiceProviderProfile(newServiceProvider),
    invalidateKeys: [queryKeys.adminProfiles.all],
    successMessage: "Service provider profile created",
  });
}

export function useUpdateAdminEmailPreferences(successMessage: string, failureMessage: string) {
  return useMutationWithUI({
    mutationFn: (preferences: AdminEmailPreferences) => updateAdminEmailPreferences(preferences),
    // Personal-only preference — nothing another role can view, so no
    // dashboards.all cascade needed (Rule 2 exemption).
    invalidateKeys: [queryKeys.adminProfiles.emailPreferences()],
    successMessage,
    failureMessage,
    // Toggle UX — no full-screen overlay per flip
    showLoadingOverlay: false,
  });
}
